/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RoleResponse } from "./RoleResponse";
export const ListRolesResponse = core.serialization.object({
    data: core.serialization.list(RoleResponse),
});
